import { inBiliApp, isSupport, biliBridge, initEnv } from '@bilibili/js-bridge'
import QRCode from 'qrcode'
import Url from 'url-parse'
import { trimHttp } from './trimHttp'
import axios from './request'

export function objectToHump(data) {
    if (typeof data === 'object') {
        return JSON.parse(JSON.stringify(data).replace(/\"(\w+)\"\:/g, function(_all, letter){
            return `"${letter.replace(/\_(\w)/g, function(_all2, letter2){
                return letter2.toUpperCase()
            })}":`
        }))
    }
    return data
}

export const goToLogin = (cb) => {
    const loginUrl = `https://passport.bilibili.com/login?gourl=${encodeURIComponent(window.location.href)}`
    if (inBiliApp) {
        isSupport('auth.login').then(support => {
            if (support) {
                biliBridge.callNative({
                    method: 'auth.login',
                    data: {
                        type: 'default'
                    },
                    onLogin (data) {
                        if (data.state === 1) {
                            cb && cb()
                            window.location.reload()
                        }
                    }
                })
            } else {
                window.location.href = loginUrl
            }
        })
    } else {
        window.location.href = loginUrl
    }
}

export const getLoginInfo = () => {
    return axios({
        url: '//api.bilibili.com/x/web-interface/nav',
        errorToast: false
    }).then(res => {
            window.__VIOLET_LOGIN_INFO__ = { isLogin: false }
            if (!res) {
                return window.__VIOLET_LOGIN_INFO__
            }
            res.face = trimHttp(res.face)

            Object.assign(window.__VIOLET_LOGIN_INFO__, {
                isLogin: true,
            }, objectToHump(res))
            return window.__VIOLET_LOGIN_INFO__
        })
}

export function getUrlQuery() {
    const obj = {}
    let search = location.href
    if (search.indexOf('?') > -1) search = search.slice(1)
    const searchArr = search.split('&')
    for (let i = 0; i < searchArr.length; i++) {
        const query = searchArr[i]
        const [ key, val ] = query.split('=')
        obj[key] = val
    }
    return obj
}

// 生成从minNum到maxNum的随机数
export function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min + 1) ) + min;
  }

export function qrcodeUrl(url) {
    return new Promise((res, rej) => {
        const canvas = document.createElement('canvas')
        QRCode.toCanvas(canvas, url || window.location.href, function (error, url) {
            if (error) {
                rej(error)
            }
            res(url.toDataURL('image/png'))
            canvas.remove()
          })
    })
}

export function debounce(fn, wait){
    const timer = null
    return function(){
        if (timer !== null){
            clearTimeout(timer)
        }
        timer = setTimeout(fn, wait)
    }
}

export function throttle(fn, wait){
    let pre = Date.now()
    return function(){
        const args = arguments
        const now = Date.now()
        if ( now - pre >= wait){
            fn.apply(this, args)
            pre = Date.now()
        }
    }
}

export function isPc() {
    var ua = window.navigator.userAgent,
    agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod', 'iPad'],
    isPC = true;
    for (var i = 0, len = agents.length; i < len; i++) {
        if (ua.indexOf(agents[i]) > 0) {
            isPC = false;
            break;
        }
    }
    return isPC;
}

export function parseUrl(url = location.href) {
    return new Url(url)
}

export function addUrlParam(key, val) {
  const search = document.location.search
  var newParam = key + '=' + val,
  params = '?' + newParam;
  if (search) {
    params = search.replace(new RegExp('[?]' + key + '[^&]*'), "?" + newParam);
    params = params.replace(new RegExp('[&]' + key + '[^&]*'), "&" + newParam);
  }
  if (params === search) {
  params += '&' + newParam;
  }
  return 'https://' + document.location.host + document.location.pathname + params;
 };

export function getElementToPageTop(el) {
  if(el.parentElement) {
    console.log(getElementToPageTop(el.parentElement) + el.offsetTop, el.parentElement)
    return getElementToPageTop(el.parentElement) + el.offsetTop
  }
  return el.offsetTop
  }
// 滚动到指定dom位置，支持偏移量 + 向下偏移， -向上偏移
export function scrollY(scrollEle, targetEle, offsert) {
  const height = getElementToPageTop(targetEle);
  (scrollEle || window).scrollTo({
    top: height - offsert,
    behavior: "smooth"
  });
}

export function callNative(options, errCb) {
    if (options.method) {
        isSupport(options.method).then((support) => {
            if (support) {
                biliBridge.callNative(options);
            } else {
                errCb && errCb();
            }
        });
    }
}

export const isProd = process.env.NODE_ENV === 'production'

export function getMeta(metaName) {
  const metas = document.getElementsByTagName('meta');
  for (let i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute('name') === metaName) {
      return metas[i].getAttribute('content');
    }
  }
  return '';
}

/**
 * 获取app当前信息
 * @param {function} callback 回调 info返回内容详见jsb文档
 *
 */
export const getAppInfo = (callback = () => {}) => {
  if (inBiliApp) {
    initEnv()
    isSupport('global.getContainerInfo').then(support => {
      if (support) {
        // 获取当前 app 信息
        biliBridge.callNative({
          method: 'global.getContainerInfo',
          callback: function (info) {
            callback(info)
          }
        })
      }
    })
  }
}

export const webp = (function() {
  try {
    return (document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0);
  } catch (err) {
    return false
  }
})()

export function webpImg(url, w, h, c = false) {
  if (!url) {
    return url
  }
  const suffix = url.match(/(.*\.(jpg|jpeg|gif|png))(\?.*)?/);
  // 路径是否包含/bfs/
  const isBfs = url.indexOf('/bfs/') !== -1;
  // 是否是GIF图片
  if (!suffix || suffix[2] === 'gif' || !isBfs) {
    return trimHttp(url)
  }
  // 裁剪规则
  w = Math.ceil(w)
  h = Math.ceil(h)
  let cut = (w && h) ? '@' + w + 'w_' + h + 'h' : '@'
  if (c) cut += '_1c'
  // 图片后参数 比如视频动态图
  const args = suffix[3] ? suffix[3] : ''
  if (webp) {
    return trimHttp(suffix[1] + cut + '.webp' + args)
  } else {
    return trimHttp(suffix[1] + cut + '.' + suffix[2] + args)
  }
}

export const isIpad = (window.navigator.userAgent || '').toLowerCase().indexOf('ipad') !== -1

const UA = window.navigator.userAgent
export const isWechat = /MicroMessenger/i.test(UA)